import { j as e } from "./jsx-runtime-DywqP_6a.js";
import { u as o, L as s, a as t, i as a } from "./chunk-PVWAREVJ-BO6B-RAk.js";
import { UnlinkIcon as n } from "lucide-react";
import { C as i } from "./CategoryHeading-BGCNu3VK.js";
import { T as d, H as c, D as m, E as l } from "./ErrorAlert-xpVkFS_n.js";
const p = () => {
  const r = o();
  return /* @__PURE__ */ e.jsxs(d, { className: "h-full pt-(--padding-content-top)", children: [
    /* @__PURE__ */ e.jsx(i, { children: "404" }),
    /* @__PURE__ */ e.jsxs(c, { level: 1, className: "flex gap-3.5 items-center", children: [
      "Page not found",
      /* @__PURE__ */ e.jsx(n, { size: 24 })
    ] }),
    /* @__PURE__ */ e.jsxs(m, { children: [
      "Start by adding a file at",
      " ",
      /* @__PURE__ */ e.jsxs("code", { children: [
        "{DOCUMENT_ROOT}",
        "/",
        r["*"],
        ".mdx"
      ] }),
      " ",
      "and add some content to make this error go away. By default",
      " ",
      /* @__PURE__ */ e.jsx("code", { children: "DOCUMENT_ROOT" }),
      " is the `pages` directory."
    ] }),
    /* @__PURE__ */ e.jsx("p", { children: "It seems that the page you are looking for does not exist or may have been moved. Please check the URL for any typos or use the navigation menu to find the correct page." }),
    /* @__PURE__ */ e.jsx(s, { to: "/", children: "Go back home" })
  ] });
};
function j() {
  const r = t();
  return a(r) && r.status === 404 ? /* @__PURE__ */ e.jsx(p, {}) : /* @__PURE__ */ e.jsx(l, { error: r });
}
export {
  p as N,
  j as R
};
//# sourceMappingURL=RouterError-D1I15Qyy.js.map
